import { S1dbgS1dbm01Component } from './s1dbg-s1dbm01.component';

export { S1dbgModule } from './s1dbg.module';

export const S1dbgSubComponentsMap = {
	
};

export const S1dbgComponentsMap = {
	"s1dbg-s1dbm01": S1dbgS1dbm01Component
};

export const S1dbgComponents = [
	S1dbgS1dbm01Component
];

